import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const SortFilterBarNewDesignWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  width: 100%;

  border-bottom: 1px solid ${theme.color.border.divider};
  padding-bottom: 1rem;
`;

export const DrawerWrapper = styled.div`
  padding: 1.25rem;
`;
